import { useCallback } from "react";

import { getPlanDetailUrl } from "@/lib/chillnn/get-detail-url";

import { useProductDayTripPlanFormModelContext } from "../../../../../../model";
import { useProductExistingDayTripPlanFormModelContext } from "../../../../context";

export const useActions = () => {
	const { onSetViewModel, viewModel } = useProductDayTripPlanFormModelContext();
	const { isDirty, hasError, inSale, hotelID, planID } = viewModel;
	const { onUpdate } = useProductExistingDayTripPlanFormModelContext();

	const isValid = !hasError && isDirty;

	const handleChangeInSale = useCallback(
		(_input: boolean | undefined) => {
			if (inSale.value) {
				// 公開中なので、非公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: false,
							value: false,
						},
					},
				]);
			} else {
				// 非公開中なので、公開にする
				onSetViewModel([
					{
						key: "inSale",
						value: {
							isEdited: true,
							value: true,
						},
					},
				]);
			}
		},
		[inSale.value, onSetViewModel],
	);

	const handleClickPreviewButton = useCallback(() => {
		onUpdate();

		const url = getPlanDetailUrl(hotelID, planID);
		window.open(url, "_blank");
	}, [hotelID, onUpdate, planID]);

	return {
		isValid,
		onUpdate,

		// 公開非公開に関するプロパティ
		inSale,
		handleChangeInSale,

		handleClickPreviewButton,
	};
};
